// src/constants/locale.js

export const Priority = ["en", "tc", "sc"];
export const GLOBE_SYMBOL = "🌏︎";
export const TRANSLATIONS = {
  en: {
    locale_symbol: "EN",
    label: "EN",
    fontsize: "Font Size",
    validation: {
      required: "Please input this field",
      mutex: {
        conflict: {
          _default: "Each option can only be selected once",
          preferred_first_and_second_session:
            "Please select different sessions for your first and second preferences",
        },
      },
      length: {
        min: "Minimum length should be {min}",
        max: "Maximum length should be {max}",
        between: "Length should be between {min} and {max}",
        exact: "Length should be exactly {length}",
        count: "characters",
      },
      areacode: {
        required: "Area code is required",
        max: "Area code cannot exceed {max} digits",
      },
      phone: {
        required: "Phone number is required",
        min: "Phone number must be at least {min} digits",
        max: "Phone number cannot exceed {max} digits",
      },
      rows: {
        min: "Minimum number of rows should be {min}",
        max: "Maximum number of rows should be {max}",
        between: "Number of rows should be between {min} and {max}",
        exact: "Number of rows should be exactly {count}",
        count: "rows",
      },
      items: {
        count: "Currently inputing {current}/{max_count} items",
      },
      regex: "Please input in correct format",
      example: "Example: {example}",
      selections: {
        min: "Please select at least {min} options",
        max: "Please select no more than {max} options",
        between: "Please select between {min} and {max} options",
        exact: "Please select exactly {count} options",
      },

      otherRequired: "Please specify",
      otherMaxLength: "Please enter no more than {max} characters",

      picsRequired:
        "Please click the check box to confirm that you have read and understood the Personal Information Collection Statement.",
    },
    form: {
      submit: "Submit",
      submitting: "Submitting...",
      pleaseSelect: "Please select",
      mandatoryField: "Mandatory",
      clear: "Clear",
      close: "Close",
      pleaseSpecify: "Please specify",
      list: {
        add: "Add item",
        remove: "Remove item",
      },
      phone: {
        areaCode: "Area Code",
        phoneNumber: "Phone Number",
      },
      submission_ref_msg: "(Ref. No.: {submission_id})",
      availability: {
        notStarted: "This form will be available from {datetime}. ",
        expired: "Online registration was closed on {datetime}. ",
        unavailable: "This form is currently not available. ",
      },
      forInquiry: "For inquiries, please contact us at {contact_email}.",
      captcha: {
        placeholder: "Enter code",
      },
      picsAcknowledgment:
        "I have read and understood the Personal Information Collection Statement",
      scrollToAccept:
        "Please scroll down and read the following Personal Information Collection Statement.",
    },
    errors: {
      captchaRequired: "Please complete the CAPTCHA verification",
      captchaExpired: "CAPTCHA has expired, please try again",
      captchaInvalid: "Incorrect CAPTCHA, please try again",
      formNotFound: "Form not found",
      formNotAvailable: "This form is not available",
      invalidRequest: "Invalid request, please check your input",
      unknownError: "An unexpected error occurred. Please try again later.",
      submitFailed: "Failed to submit form. Please try again.",
    },
  },
  tc: {
    locale_symbol: "繁",
    label: "繁",
    fontsize: "字型大小",
    validation: {
      required: "請輸入此欄位",
      mutex: {
        conflict: {
          _default: "每個選項只能選擇一次",
          preferred_first_and_second_session:
            "請選擇兩個不同的環節作為你的首選及次選",
        },
      },
      length: {
        min: "長度最小應為 {min}",
        max: "長度最大應為 {max}",
        between: "長度應在 {min} 至 {max} 之間",
        exact: "長度必須為 {length}",
        count: "字",
      },
      areacode: {
        required: "請輸入區號",
        max: "區號不能超過 {max} 位",
      },
      phone: {
        required: "請輸入電話號碼",
        min: "電話號碼至少需要 {min} 位",
        max: "電話號碼不能超過 {max} 位",
      },
      rows: {
        min: "最少行數應為 {min}",
        max: "最多行數應為 {max}",
        between: "行數應在 {min} 至 {max} 之間",
        exact: "行數必須為 {count}",
        count: "行",
      },
      items: {
        count: "正在輸入 {current}/{max} 項",
      },
      regex: "請按正確格式輸入",
      example: "例子：{example}",
      selections: {
        min: "請最少選擇 {min} 項",
        max: "請最多選擇 {max} 項",
        between: "請選擇 {min} 至 {max} 項",
        exact: "請選擇 {count} 項",
      },

      picsRequired: "請勾選方格以確認您已閱讀並明白收集個人資料聲明",
    },
    form: {
      submit: "提交",
      submitting: "提交中...",
      pleaseSelect: "請選擇",
      mandatoryField: "必須填寫",
      clear: "清除",
      close: "關閉",
      pleaseSpecify: "請說明",
      list: {
        add: "新增",
        remove: "移除",
      },
      phone: {
        areaCode: "區號",
        phoneNumber: "電話號碼",
      },
      submission_ref_msg: "(參考編號：{submission_id})",
      availability: {
        notStarted: "此表格將於{datetime}開始接受填寫。",
        expired: "網上報名已於{datetime}截止。",
        unavailable: "此表格暫時未能使用。",
      },
      forInquiry: "如有查詢，請透過電郵 {contact_email}與我們聯絡。",
      captcha: {
        placeholder: "輸入驗證碼",
      },
      picsAcknowledgment: "我已閱讀並明白收集個人資料聲明",
      scrollToAccept: "請向下滑動並閱讀以下收集個人資料聲明",
    },
    errors: {
      captchaRequired: "請完成驗證碼驗證",
      captchaExpired: "驗證碼已過期，請重試",
      captchaInvalid: "驗證碼不正確，請重試",
      formNotFound: "表格不存在",
      formNotAvailable: "此表格現時不可用",
      invalidRequest: "無效的請求，請檢查輸入",
      unknownError: "發生意外錯誤。請稍後再試。",
      submitFailed: "提交表格失敗。請重試。",
    },
  },
  sc: {
    locale_symbol: "簡",
    label: "簡",
    fontsize: "字型大小",
    validation: {
      required: "请输入此栏位",
      mutex: {
        conflict: {
          _default: "每个选项只能选择一次",
          preferred_first_and_second_session:
            "请选择两个不同的环节作为你的首选及次选",
        },
      },
      length: {
        min: "长度最小应为 {min}",
        max: "长度最大应为 {max}",
        between: "长度应在 {min} 至 {max} 之间",
        exact: "长度必须为 {length}",
        count: "字",
      },
      areacode: {
        required: "请输入区号",
        max: "区号不能超过 {max} 位",
      },
      phone: {
        required: "请输入电话号码",
        min: "电话号码至少需要 {min} 位",
        max: "电话号码不能超过 {max} 位",
      },
      rows: {
        min: "最少行数应为 {min}",
        max: "最多行数应为 {max}",
        between: "行数应在 {min} 至 {max} 之间",
        exact: "行数必须为 {count}",
        count: "行",
      },
      items: {
        count: "正在输入 {current}/{max} 项",
      },
      regex: "请按正确格式输入",
      example: "例子：{example}",
      selections: {
        min: "请最少选择 {min} 项",
        max: "请最多选择 {max} 项",
        between: "请选择 {min} 至 {max} 项",
        exact: "请选择 {count} 项",
      },
      picsRequired: "请勾选方格以确认您已阅读并明白收集个人资料声明",
    },
    form: {
      submit: "提交",
      submitting: "提交中...",
      pleaseSelect: "请选择",
      mandatoryField: "必须填写",
      clear: "清除",
      close: "关闭",
      pleaseSpecify: "请说明",
      list: {
        add: "新增",
        remove: "移除",
      },
      phone: {
        areaCode: "区号",
        phoneNumber: "电话号码",
      },
      submission_ref_msg: "(参考编号：{submission_id})",
      availability: {
        notStarted: "此表格将于{datetime}开始接受填写。",
        expired: "网上报名已于{datetime}截止。",
        unavailable: "此表格暂时未能使用。",
      },
      forInquiry: "如有查询，请透过电邮 {contact_email}与我们联络。",
      captcha: {
        placeholder: "输入验证码",
      },
      picsAcknowledgment: "我已阅读并明白收集个人资料声明",
      scrollToAccept: "请向下滑动并阅读以下收集个人资料声明",
    },
    errors: {
      captchaRequired: "请完成验证码验证",
      captchaExpired: "验证码已过期，请重试",
      captchaInvalid: "验证码不正确，请重试",
      formNotFound: "表格不存在",
      formNotAvailable: "此表格现时不可用",
      invalidRequest: "无效的请求，请检查输入",
      unknownError: "发生意外错误。请稍后再试。",
      submitFailed: "提交表格失败。请重试。",
    },
  },
};

const _t = (key, language, replaceDict = {}) => {
  const keys = key.split(".");
  let value = TRANSLATIONS[language];

  for (const k of keys) {
    value = value?.[k];
    if (value === undefined) {
      console.warn(
        `Translation missing for key: ${key} in language: ${language}`
      );
      return null;
    }
  }

  // Replace placeholders in the translation value with values from replaceDict
  for (const [placeholder, replaceValue] of Object.entries(replaceDict)) {
    value = value.replace(`{${placeholder}}`, replaceValue);
  }
  return value;
};

// Helper function to get translation
export const t = (key, language, replaceDict = {}) => {
  const keys = key.split(".");
  let value = _t(key, language, replaceDict);

  if (value == null) {
    for (const lang of Priority) {
      if (lang !== language) {
        value = _t(key, lang, replaceDict);
        if (value !== null) {
          return value;
        }
      }
    }
  }

  if (value == null) {
    console.warn(`Translation not found for key: ${key} in any language`);
    return "";
  }

  return value;
};

export const getPresetMutexIds = () => {
  // Get the mutex conflict settings from any language (structure should be the same)
  const mutexConflicts = TRANSLATIONS.en.validation.mutex.conflict;

  // Filter out the _default key and create a list of preset IDs
  return Object.entries(mutexConflicts)
    .filter(([key]) => key !== "_default")
    .map(([key, value]) => ({
      id: key,
      message: value,
    }));
};
